import { Component, Input } from '@angular/core';
import {
    AccountAddress,
    InvoiceDetail,
    PaymentProfileCardsResponse,
} from '@viewbid/ts-angular-client';
import { PickupSlot } from '../../../../model/pickup-slot';
import { Router } from '@angular/router';

/**
 * Post-confirm success view (handoff §7) — replaces the stepper inside the
 * hero card: green check + title, emailed-confirmation line, ORDER SUMMARY
 * read-back card, schedule-later / proxy-ID notes, and the two exit CTAs.
 */
@Component({
    selector: 'vb-invoice-order-confirm',
    templateUrl: './invoice-order-confirm.component.html',
    styleUrls: ['./invoice-order-confirm.component.scss'],
})
export class InvoiceOrderConfirmComponent {
    @Input() paymentSuccess: boolean = false;
    @Input() isPayOnPickup: boolean = false;
    @Input() invoiceDetails: InvoiceDetail | null = null;
    @Input() scheduleLater: boolean = false;
    @Input() selectedDeliveryMethod: string | null = null;
    @Input() selectedDate: string | number | Date | undefined;
    @Input() selectedSlot: PickupSlot | null = null;
    @Input() proxyName: string = '';
    @Input() proxyTelephone: string = '';
    @Input() selectedShippingAddress: AccountAddress | null = null;
    @Input() selectedPaymentCard: PaymentProfileCardsResponse | null = null;

    constructor(private router: Router) {}

    get successTitle(): string {
        return this.isPayOnPickup ||
            this.invoiceDetails?.invoice?.isPaidInFull ||
            this.scheduleLater
            ? 'Order confirmed'
            : 'Payment successful';
    }

    get isPickupBranch(): boolean {
        return (
            this.selectedDeliveryMethod === 'pickup' ||
            this.selectedDeliveryMethod === 'proxyPickup'
        );
    }

    get isPaidInFull(): boolean {
        return !!this.invoiceDetails?.invoice?.isPaidInFull;
    }

    get shipLine(): string {
        const address: AccountAddress | null = this.selectedShippingAddress;
        if (!address) return '';
        return [address.address1, address.address2, address.postalCode]
            .filter((part?: string) => !!part)
            .join(', ');
    }

    goBack(): void {
        this.router.navigate(['profiles/my-profile/my-invoices'], {
            replaceUrl: true,
        });
    }

    goToAllAuctions(): void {
        this.router.navigate(['auctions'], {
            replaceUrl: true,
        });
    }
}
